<div class="relative">
  <button type="button" class="header-action" aria-haspopup="menu" [attr.aria-expanded]="open"
    title="Preferiti" (click)="toggle()">
    <fa-icon [icon]="['fas', 'star']" aria-hidden="true"></fa-icon>
    <span class="hidden min-[1200px]:inline">Preferiti</span>
  </button>

  @if (open) {
    <div class="absolute left-0 top-full z-[1100] mt-2 w-80 overflow-hidden rounded-xl border border-fq-border-soft bg-fq-surface shadow-2xl" role="menu">
      <div class="flex items-center justify-between border-b border-fq-border-soft px-3 py-2">
        <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Preferiti</span>
        <span class="text-[11px] text-fq-text-muted">{{ nav.favoriteItems().length }}/{{ nav.maxFavorites }}</span>
      </div>

      @if (nav.favoriteItems().length === 0) {
        <div class="px-4 py-6 text-center text-xs text-fq-text-muted">
          <fa-icon [icon]="['fas', 'thumbtack']" class="mb-2 text-base opacity-60" aria-hidden="true"></fa-icon>
          <div>Nessun preferito.</div>
          <div class="mt-1">Passa il mouse su una voce del menu e clicca il pin.</div>
        </div>
      } @else {
        <div class="max-h-[60vh] overflow-y-auto py-1">
          @for (item of nav.favoriteItems(); track item.url) {
            <div class="group flex items-center gap-1 px-2 hover:bg-fq-surface-muted">
              <a [routerLink]="item.url" class="flex min-w-0 flex-1 items-center gap-2 px-1 py-2 text-sm text-fq-text-2" (click)="close()" role="menuitem">
                <i [class]="item.icon" class="w-4 shrink-0 text-center text-fq-primary"></i>
                <span class="min-w-0 flex-1">
                  <span class="block truncate font-medium">{{ item.name }}</span>
                  @if (item.parent) {
                    <span class="block truncate text-[11px] text-fq-text-muted">{{ item.parent }}</span>
                  }
                </span>
              </a>
              <button type="button" class="inline-flex h-6 w-6 items-center justify-center rounded text-fq-text-muted opacity-0 transition hover:bg-fq-surface-subtle hover:text-fq-danger group-hover:opacity-100"
                title="Rimuovi dai preferiti" aria-label="Rimuovi dai preferiti" (click)="remove(item.url, $event)">
                <fa-icon [icon]="['fas', 'xmark']" aria-hidden="true"></fa-icon>
              </button>
            </div>
          }
        </div>
      }

      <div class="border-t border-fq-border-soft px-3 py-2 text-[11px] text-fq-text-muted">
        Clicca il pin nel menu per aggiungere o rimuovere.
      </div>
    </div>
  }
</div>
